import { Helmet } from 'react-helmet-async';
import faqsList from '../data/faqs';
import SectionPageTitle from '../components/SectionPageTitle';
import Faq from '../components/Faq';
import SocialLinks from '../components/SocialLinks';
import mission from '../imgs/mission.webp';
import daniel from '../imgs/team/daniel.webp';
import albert from '../imgs/team/albert.webp';
import lucia from '../imgs/team/lucia.webp';
import philip from '../imgs/team/philip.webp';

export default function About() {
	return (
		<>
			<Helmet>
				<title>About Us</title>
				<meta name="description" content="Our mission is to drive your success through innovative and tailored IT solutions" />
				<meta name="keywords" content="team it solution, expert team, about, mission, it solutions, business" />
			</Helmet>

			<SectionPageTitle
				pageTitle={'About Us'} 
				subTitle={'Our history'}
			/>

			<section className="container grid g-2">
				<div className="print flex">
					<img src={mission} alt="About us - Gersem: Business Services & IT Solutions HTML Website Template" />
				</div>

				<article>
					<h1>Who <span className="txt-gradient">We are</span></h1>

					<h2>Much more than an IT team</h2>
					<p>Welcome to Gersem, where innovation meets reliability. Founded on the principles of cutting-edge technology and unwavering commitment to excellence, we are your trusted partner for business services and IT solutions.</p>
					<p>At Gersem, we are a team of passionate professionals dedicated to empowering businesses with transformative technology solutions. With a rich history of successful partnerships and a forward-thinking approach, we strive to be at the forefront of the ever-evolving tech landscape.</p>

					<h2>Our Mission</h2>
					<p className="mb-3">Our mission is to drive your success through innovative and tailored IT solutions. We believe in the power of technology to propel businesses forward, and we are committed to delivering solutions that not only meet but exceed your expectations.</p>
				</article>
			</section>
			
			<section className="accent-end">
				<div className="container mb-8">
					<h1 className="txt-gradient">We Have Expert Team</h1>
					<div className="grid gtc-4 g-2">
						<article>
							<img src={daniel} className="mb-1" alt="Gersem team" />
							<h2 className="mb-0">Daniel Grayson</h2>
							<p>CEO</p>
							<SocialLinks />
						</article>
						
						<article>
							<img src={lucia} className="mb-1" alt="Gersem team" />
							<h2 className="mb-0">Lucia Mason</h2>
							<p>Head Manager</p>
							<SocialLinks />
						</article>

						<article>
							<img src={philip} className="mb-1" alt="Gersem team" />
							<h2 className="mb-0">Philip Jopher</h2>
							<p>Developer</p>
							<SocialLinks />
						</article>

						<article>
							<img src={albert} className="mb-1" alt="Gersem team" />
							<h2 className="mb-0">Albert Coffin</h2>
							<p>Chief Expert</p>
							<SocialLinks />
						</article>
					</div>
				</div>
			</section>


			<section className="container">
				<h1 className="txt-center mb-4">Frequently Asked <span className="txt-gradient">Questions</span></h1>

				<div className="grid g-2 mb-8">
					<article>
						{faqsList.slice(0, 4).map((faq, idx) =>
							<Faq
								key={idx}
								question={faq.question}
								answer={faq.answer}
							/>
						)}
					</article>

					<ul>
						<li>
							<h3 className='mb-3'>Gersem Solutions:</h3>
						</li>
						<li>
							<h2><span className="pictogram" /> IT Consultancy</h2>
						</li>
						<li>
							<h2><span className="pictogram" /> Software Development</h2>
						</li>
						<li>
							<h2 className="mb-0"><span className="pictogram" /> Cybersecurity</h2>
						</li>
					</ul>
				</div>

			</section>

		</>
	);
}
